export function getVacancyStatus(
  actual: string | null,
  expireDate: string | null
): "unpublished" | "published" | "expired" {
  const now = new Date();
  const isExpired = expireDate ? new Date(expireDate) < now : false;
  const isUnpublished = !actual || new Date(actual) > now;

  if (isUnpublished) return "unpublished";
  if (isExpired) return "expired";
  return "published";
}
